<input #nativeInput class="klab-input-base__element" [class.klab-input-base__element--search-large]="variant === 'search-large'" [type]="type" [placeholder]="placeholder" [disabled]="disabled" [value]="value"
    (input)="onInput($event)" (blur)="onBlur()"/>
